export default __webpack_public_path__ + "static/media/Levitate D4.3 Feasible paths of interventions.ac0be151.pdf";